<kw-wrapper [wrapperClass]="wrapperClass" [bgColor]="bgColor" [border]="border" [borderRadius]="borderRadius">
    <ng-container *ngIf="!preview">
        <kw-title-renderer class="section-title" [title]="title"></kw-title-renderer>
    </ng-container>
    <!-- <div *ngIf="edit" class="download-button">
        <button nbButton size="small" status="primary" (click)="export('grid-3')">Download</button>
    </div>  kve-banner-renderer -->
    <div [ngClass]="layoutClass">
        <kw-grid-cell-wrapper [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId"
            [attr.content-enum]="gridCell.contentEnum" class="grid-cell-container cell-shadow"
            *ngFor="let gridCell of gridCells" [gridCell]="gridCell" kweOptionalClasses>
            <ng-container [ngSwitch]="gridCell?.contentEnum">
                <!-- <ng-container *ngSwitchCase="'Banner'">
                    <kve-banner-renderer></kve-banner-renderer>
                </ng-container>
                <ng-container *ngSwitchCase="'BANNER'">
                </ng-container> -->
                <ng-container *ngSwitchCase="'Banner'">
                    <ng-container *ngIf="!edit; else editing">
                        <div class="bg-img-layer fok-you-too-man"
                            [style.--bg-image]="'url(' + gridCell.imgSrc + ')'|safeStyle "></div>
                        <kw-fill-layer-renderer [fillClass]="gridCell.fillClass"
                            [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                        <div class="content-layer">
                            <div class="content-layout" [ngClass]="gridCell.layoutClass">
                                <div *ngFor="let contentElement of gridCell.contentElements"
                                    [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview"
                                        (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #editing>
                        <ng-container *ngIf="gridCell.status === 'Initial Draft';else inProgress">
                            <div class="bg-img-layer fok-you-too-man"
                                [style.--bg-image]="'url(' + gridCell.imgSrc + ')'|safeStyle "></div>
                            <kw-fill-layer-renderer [fillClass]="gridCell.fillClass"
                                [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                            <div class="content-layer">
                                <div class="content-layout" [ngClass]="gridCell.layoutClass">
                                    <div *ngFor="let contentElement of gridCell.contentElements"
                                        [ngClass]="contentElement.containerClasses"
                                        [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                        <kw-content-element-renderer [contentElement]="contentElement"
                                            [preview]="preview"
                                            (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #inProgress>
                            <kw-edit-placeholder-renderer [gridCell]="gridCell"
                                (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
                        </ng-template>
                    </ng-template>
                </ng-container>
                <ng-container *ngSwitchCase="'BANNER'">
                    <ng-container *ngIf="!edit; else editing">
                        <div class="bg-img-layer fok-you-too-man"
                            [style.--bg-image]="'url(' + gridCell.imgSrc + ')'|safeStyle "></div>
                        <kw-fill-layer-renderer [fillClass]="gridCell.fillClass"
                            [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                        <div class="content-layer">
                            <div class="content-layout" [ngClass]="gridCell.layoutClass">
                                <div *ngFor="let contentElement of gridCell.contentElements"
                                    [ngClass]="contentElement.containerClasses"
                                    [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview"
                                        (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #editing>
                        <ng-container *ngIf="gridCell.status === 'Initial Draft';else inProgress">
                            <div class="bg-img-layer fok-you-too-man"
                                [style.--bg-image]="'url(' + gridCell.imgSrc + ')'|safeStyle "></div>
                            <kw-fill-layer-renderer [fillClass]="gridCell.fillClass"
                                [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
                            <div class="content-layer">
                                <div class="content-layout" [ngClass]="gridCell.layoutClass">
                                    <div *ngFor="let contentElement of gridCell.contentElements"
                                        [ngClass]="contentElement.containerClasses"
                                        [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                        <kw-content-element-renderer [contentElement]="contentElement"
                                            [preview]="preview"
                                            (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #inProgress>
                            <kw-edit-placeholder-renderer [gridCell]="gridCell"
                                (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
                        </ng-template>
                    </ng-template>
                </ng-container>
                <ng-container *ngSwitchCase="'Product Link'">
                    <kw-product-link-renderer [gridCell]="gridCell" [edit]="edit"
                        (createGridCellContent)="createContent($event)"></kw-product-link-renderer>
                </ng-container>
                <ng-container *ngSwitchCase="'ContentEnum.PRODUCT_LINK'">
                    <kw-product-link-renderer [gridCell]="gridCell" [edit]="edit"
                        (createGridCellContent)="createContent($event)"></kw-product-link-renderer>
                </ng-container>
                <ng-container *ngSwitchCase="'Product Content'">
                    <img src="{{gridCell.imgSrc}}" />
                    <div class="grid-cell-header">
                        <div class="header-inner">{{gridCell?.heading.headerText?? "Header"}}</div>
                    </div>
                    <div class="grid-cell-footer">
                        <div class="footer-inner">
                            {{gridCell?.footer.footerText?? "Footer"}}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Blog Article Link'">
                    <kw-blog-article-link-renderer [gridCell]="gridCell" [edit]="edit"
                        (createGridCellContent)="createContent($event)"></kw-blog-article-link-renderer>
                </ng-container>
                <ng-container *ngSwitchCase="'Category Link'">
                    <img src="{{gridCell.imgSrc}}" />
                    <div class="grid-cell-header">
                        <div class="header-inner">{{gridCell?.heading.headerText?? "Header"}}</div>
                    </div>
                    <div class="grid-cell-footer">
                        <div class="footer-inner">
                            {{gridCell?.footer.footerText?? "Footer"}}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Call To Action'">
                    <!-- <div class="bg-img-layer fok-you-too-man"></div> -->
                    <kw-call-to-action-renderer [gridCell]="gridCell" [edit]="edit"
                        (createGridCellContent)="createContent($event)"></kw-call-to-action-renderer>
                </ng-container>
                <ng-container *ngSwitchCase="'Category Content'">
                    <img src="{{gridCell.imgSrc}}" />
                    <div class="grid-cell-header">
                        <div class="header-inner">{{gridCell?.heading.headerText?? "Header"}}</div>
                    </div>
                    <div class="grid-cell-footer">
                        <div class="footer-inner">
                            {{gridCell?.footer.footerText?? "Footer"}}
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <!-- <img src="{{gridCell.imgSrc}}"/>     -->

        </kw-grid-cell-wrapper>
    </div>
</kw-wrapper>